
import './App.css';
import Content from './components/Content';
import ImageData from './components/ImageData';
import UploadImage from './components/UploadImage';

function App() {
  return (
    <div className="App">
      <Content/>
      <UploadImage/>
    </div>
  );
}

export default App;
